import { useEffect } from "react";
import { markMounted } from "../../../utilities/bootWatchdog";

// Renders nothing. Its only job is to run once on the first React commit and
// tell the boot sentinel (src/bootSentinel.js) that the app is on screen —
// `root.render()` returning proves nothing in React 18, the commit is async.
// Mount it inside the Sentry.ErrorBoundary: if the tree crashes, this effect
// never runs and the boundary's fallback marks the stage instead.
const BootMark = () => {
    useEffect(() => {
        markMounted();
    }, []);
    return null;
};

export default BootMark;
